import React from 'react';
import './App.css';

import Routes from './routes';

export default () => (
  <Routes />
);



// WEBPACK FOOTER //
// ./src/App.js